import { Wrench, Rocket, Briefcase, Check } from "lucide-react";
import { PAIN_POINTS } from "@/content/copy";

const ICONS = { Wrench, Rocket, Briefcase };

export default function PainPoints() {
  return (
    <section data-testid="pain-points-section" className="py-20 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <p className="text-sm font-bold uppercase tracking-widest text-terracotta">{PAIN_POINTS.overline}</p>
          <h2 className="mt-3 text-3xl sm:text-4xl font-bold tracking-tight text-navy">{PAIN_POINTS.title}</h2>
          <p className="mt-4 text-base text-navy/70 leading-relaxed">{PAIN_POINTS.subtitle}</p>
        </div>
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 stagger">
          {PAIN_POINTS.columns.map((col) => {
            const Icon = ICONS[col.icon];
            return (
              <div
                key={col.audience}
                data-testid={`pain-card-${col.audience.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="rounded-2xl bg-background p-8 border border-border transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
              >
                <div className="w-12 h-12 rounded-xl bg-terracotta-light flex items-center justify-center">
                  <Icon className="w-6 h-6 text-terracotta" aria-hidden="true" />
                </div>
                <h3 className="mt-5 text-xl font-semibold text-navy">{col.audience}</h3>
                <ul className="mt-4 space-y-3">
                  {col.points.map((point) => (
                    <li key={point} className="flex gap-3 text-sm text-navy/70 leading-relaxed">
                      <Check className="w-4 h-4 mt-0.5 shrink-0 text-terracotta" aria-hidden="true" />
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
